import axios from 'axios';
class Api {
    static async get(url) {
        try {
            const response = await axios.get(url);
            return {
                data: response.data.data,
                success: true,
            };
        }
        catch (err) {
            if (err && err.response) {
                throw new ApiError(err.response.data.message, err.response.data.errors);
            }
            throw err;
        }
    }
    static async post(url, body) {
        try {
            const response = await axios.post(url, body);
            return {
                ...response.data,
                success: true,
            };
        }
        catch (err) {
            if (err && err.response) {
                throw new ApiError(err.response.data.message, err.response.data.errors);
            }
            throw err;
        }
    }
    static async delete(url, body) {
        try {
            const response = await axios.delete(url, { data: body });
            return {
                data: response.data.data,
                success: true,
            };
        }
        catch (err) {
            if (err && err.response) {
                throw new ApiError(err.response.data.message, err.response.data.errors);
            }
            throw err;
        }
    }
}
class ApiError extends Error {
    constructor(message, errors = []) {
        super();
        this.success = false;
        this.errors = [];
        this.message = message;
        this.errors = errors;
    }
}
export { Api, ApiError };
